<template>
    <div class="contrast">
        <div class="fixed-box">
            <div class="fixed-box-c" @click="handleDrawer(true)">
                <img src="@/common/images/contrast/PK.svg" >
                <p>对比</p>
                <span v-if="selectModel.length">{{selectModel.length}}</span>
            </div>
            <c-qrcode position="PK" />
        </div>
        <el-drawer
            custom-class="drawer-content"
            :visible.sync="drawerShow"
            :with-header="false"
            :modal="false"
            size="424px"
        >
            <h2 class="diff">
                <p>车型对比</p>
                <span v-if="selectModel.length" @click.top="delAllModel">清空全部</span>
            </h2>
            <c-model-selector
                :select-model="selectModelIds || []"
                @change="handleSelector"
            />
            <div class="selected">
                <div
                    v-for="item in selectModel"
                    class="selected-item"
                    :key="item.id"
                >
                    <p class="item-name">{{item.modelName}}</p>
                    <i class="el-icon-close" @click="handleRemove(item)"></i>
                </div>
            </div>
            <div
                class="start-btn"
                v-if="this.selectModel && this.selectModel.length >= 1"
                :class="{disabled: this.selectModel.length <= 1}"
                @click="navigateTo"
            >开始对比</div>
        </el-drawer>
    </div>
</template>

<script>
/**
 * @file 对比抽屉
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {get} from 'lodash';
import ModelSelector from 'components/model-selector';
import {openUrlInNewTab, getStorage} from '@/common/js/core';
import {on, off} from 'js/Utils';
import {visibilityChange, hidden} from 'js/pageShowHidden';
import {sendLog} from 'js/log';
import {setModel, delModel} from 'js/dataParse';
import Qrcode from '@/components/qrcode';

export default {
    components: {
        'c-model-selector': ModelSelector,
        'c-qrcode': Qrcode
    },
    props: {
        contrastList: {
            type: Array,
            default: () => []
        },
        pageName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            drawerShow: false,
            selectModel: []
        };
    },
    watch: {
        contrastList(value) {
            this.selectModel = [...value];
        }
    },
    computed: {
        selectModelIds() {
            return this.selectModel.map(v => v.id);
        }
    },
    created() {
        this.getModel();
    },
    activated() {
        if (visibilityChange) {
            on(window, visibilityChange, this.handlePageShow);
        }
    },
    deactivated() {
        off(window, visibilityChange, this.handlePageShow);
    },
    beforeDestroy() {
        off(window, visibilityChange, this.handlePageShow);
    },
    methods: {
        handleDrawer(status) {
            this.drawerShow = status;
        },
        handleSelector(item) {
            this.selectModel.unshift(item);
            setModel(item.id, item.modelName);
            this.$emit('addcontrast', item);
            this.sendLog('add_model', {
                modelId: item.id,
                modelName: item.modelName
            });
        },
        handleRemove(item, type) {
            this.selectModel = this.selectModel
                .filter(val => val.id !== item.id);
            delModel(item.id);
            this.$emit('addcontrast', item, 'del');
            if (type !== 'delAll') {
                this.sendLog('remove_model', {
                    modelId: item.id
                });
            }
        },
        getModel() {
            request(URLS.getModel)
                .then(res => {
                    const tmpList = get(res.Result, 'arrData.list', []);
                    let list = tmpList.map(v => ({
                        id: v.modelId,
                        modelName: v.name
                    }));
                    // 如果没有拉取到正确的数据，那么从本地数据中获取
                    if (!list.length) {
                        list = get(getStorage('CONTRAST_DATA'), 'data', []);
                    }
                    this.$emit('addcontrast', list, 'update');
                })
                .catch(err => {});
        },
        delAllModel() {
            const tmp = this.selectModel;
            tmp.forEach(val => {
                this.handleRemove(val, 'delAll');
            });
            this.$emit('addcontrast', [], 'update');
            this.sendLog('remove_all_model');
        },
        navigateTo() {
            if (!(this.selectModel && this.selectModel.length > 1)) {
                return;
            };
            openUrlInNewTab({
                name: 'CONSTRAST',
                query: {
                    type: 'model',
                    modelIds: this.selectModel.map(v => v.id).join(',')
                }
            });
            this.sendLog('start_contrast');
        },
        handlePageShow() {
            const status = document[hidden];
            if (!status) {
                this.getModel();
            }
        },
        sendLog(key, params) {
            sendLog(`${this.pageName}_${key}`, {
                ...params
            });
        }
    }
};
</script>

<style lang="less" scoped>
.contrast {
    position: relative;
    z-index: 9999;
    .fixed-box {
        position: fixed;
        padding: 20px 21px 0;
        width: 80px;
        height: 80px;
        right: 39px;
        top: 30%;
        margin-top: -40px;
        background: #191919;
        border-radius: 3px;
        cursor: pointer;
        &-c {
            height: 100%;;
        }
        img {
            display: block;
        }
        p {
            margin-top: 7px;
            font-size: 14px;
            line-height: 16px;
            text-align: center;
            color: #FFFFFF;
        }
        span {
            position: absolute;
            width: 28px;
            height: 28px;
            line-height: 30px;
            top: -14px;
            right: -14px;
            font-size: 16px;
            text-align: center;
            border-radius: 50%;
            color: #FFFFFF;
            background: #FF5050;
        }
    }
    .diff {
        position: relative;
        font-size: 24px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 20px;
        color: #333333;
        span {
            position: absolute;
            top: 7px;
            right: 0;
            font-size: 14px;
            justify-self: end;
            font-weight: 400;
            cursor: pointer;
        }
    }
    /deep/ .drawer-content {
        padding: 30px 30px;
        outline: none;
        box-shadow: -6px 0 24px 0 rgba(0, 0, 0, .08);
    }
    .selected {
        width: 362px;
        max-height: calc(100vh - 240px);
        overflow-y: scroll;
        margin-top: 9px;
    }
    .selected-item {
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 20px;
        padding: 16px 0;
        color: #333333;
        border-bottom: 1px solid #EEEEEE;
        .item-name {
            flex: 1;
        }
        i {
            display: block;
            width: 16px;
            margin-left: 20px;
            cursor: pointer;
        }
    }
    .start-btn {
        width: 234px;
        height: 42px;
        margin: 37px auto 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 44px;
        text-align: center;
        color: #ffffff;
        background: #00CECF;
        border-radius: 3px;
        cursor: pointer;
        user-select: none;
        &.disabled {
            color: #999999;
            background: #E4E4E4;
            cursor: not-allowed;
        }
    }
}
</style>
